import styled from 'styled-components/macro';
import styledFuncs from 'app/styles/styledFuncs';
import {
  DiagnosisQuote,
  QuoteSummery,
  QuoteDetails as RepairQuoteDetails,
} from 'app/core/api/repairer/api-repairer.types';
import { useEffect, useState } from 'react';

type Props = {
  quoteSummery?: QuoteSummery;
};
export default function PaymentDetails({
  quoteSummery,
}: Props): JSX.Element {
  const [totalAmount, setTotalAmount] = useState<number>(0);
  useEffect(() => {
    const amount = quoteSummery?.diagnosisQuote
      ? quoteSummery.diagnosisQuote
          .filter(item => !item.declined)
          .map(item => item.quotationAmount.amount)
          .reduce((prev, curr) => prev + curr, 0)
      : 0;
    const amount1 = quoteSummery?.repairQuote
      ? quoteSummery.repairQuote
          .filter(item => !item.declined)
          .map(item => item.quotationAmount.amount)
          .reduce((prev, curr) => prev + curr, 0)
      : 0;

    let total = amount + amount1;
    if (!Number.isInteger(total)) {
      total = Number(total?.toFixed(2) ?? 0);
    }
    setTotalAmount(total);
    // setTotalAmount(amount1 !== 0 ? amount1 : amount);
  }, [quoteSummery?.diagnosisQuote, quoteSummery?.repairQuote]);
  const Table = styled.table`
    border-collapse: separate;
    table-layout: fixed;
    th {
      text-align: left;
      padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)};
    }
    th:first-child {
      width: 50%;
    }
    th:nth-child(2) {
      text-align: center;
      width: 20%;
    }
    th:nth-child(3) {
      text-align: right;
      width: 30%;
    }
    tr {
      border-radius: 10px;
    }
    td {
      border-top: 1px solid #eaeaea;
      border-bottom: 1px solid #eaeaea;
      padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)};
      color: #000;
    }
    td:first-child {
      border-left: 1px solid #eaeaea;
      width: 50%;
      border-radius: 10px 0 0 10px;
      overflow-wrap: break-word;
    }
    td:nth-child(2) {
      text-align: center;
      width: 20%;
      border-right: solid 1px #fff !important;
    }
    td:last-child {
      border-right: 1px solid #eaeaea;
      border-radius: 0 10px 10px 0;
      text-align: right;
      width: 30%;
    }
    tr:last-child td {
      color: #31ad31;
    }
    thead {
      font-weight: 600;
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    tbody {
      display: table;
      table-layout: fixed;
      width: 100%;
      border-spacing: 0 10px;
    }
  `;
  return (
    <div style={{ display: 'block', margin: '0 auto' }}>
      <Table>
        <thead>
          <tr>
            <th>Description</th>
            <th>Qty</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {quoteSummery &&
            quoteSummery.diagnosisQuote &&
            quoteSummery.diagnosisQuote.map(
              (dq: DiagnosisQuote, index) =>
                // <tr key={new Date().toString()}>
                dq.declined === false && (
                  <tr key={`diagnosis${index + 1}`}>
                    <td>Diagnosis</td>
                    <td />
                    <td>£{dq.quotationAmount.amount}</td>
                  </tr>
                )
            )}
          {quoteSummery &&
            quoteSummery.repairQuote &&
            quoteSummery.repairQuote.map(
              (dq: DiagnosisQuote, index) =>
                !dq.declined &&
                (dq.quoteDetails ? (
                  dq.quoteDetails.map(
                    (rdq: RepairQuoteDetails, rdqIndex) => (
                      // new Date().toString()
                      <tr key={`repair${rdqIndex + 1}`}>
                        <td>
                          {rdq.description && rdq.description}
                          {!rdq.description && 'Repair Quote'}
                        </td>
                        <td>{rdq.qty}</td>
                        <td>
                          {rdq.qty > 1 && (
                            <span
                              style={{
                                color: '#a8a8a8',
                                float: 'left',
                              }}
                            >
                              (£{rdq.total})
                            </span>
                          )}
                          <span style={{ color: '#000000' }}>
                            £{(rdq.qty * rdq.total).toFixed(2)}
                          </span>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr key={`repair${index + 1}`}>
                    <td>Repair Quote</td>
                    <td>1</td>
                    <td>£{dq.quotationAmount.amount}</td>
                  </tr>
                ))
            )}
          <tr>
            <td>Total</td>
            <td />
            <td>£{totalAmount}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
